export default class Error404Controller {
  constructor() { }
}

 Error404Controller.$inject = [];



// WEBPACK FOOTER //
// ./src/app/pages/error-404/error-404.controller.js